<template>
    <div class="live-vip">
        <Navbar :statusHeight="statusHeight" :backIcon="require('@/assets/icon_back_white.png')"
            background="transparent" :isNavtiveBack="true">
            <template #title><span class="nav-title">{{ $t('VIP直播会员') }}</span></template>
        </Navbar>
        <div class="container">
            <div class="user-box">
                <div class="user-card" :data-text="$t(isUserHaveVip ? '已开通会员' : '未开通')">
                    <div class="user-info">
                        <img :src="userInfo.headUrl" alt="">
                        <p class="text-ellipsis" style="padding: 2px 0;">{{ userInfo.name }}</p>
                    </div>
                    <div :class="['vip-desc', isUserHaveVip && 'vip-desc-hanve']">{{ isUserHaveVip ? $t('会员到期：', {
                        time: resultDate(userInfo.liveMemberEndTime)
                    }) :
                        $t('开通VIP直播会员,获得13项会员特权') }}</div>
                </div>
                <div class="vip-box-model"></div>
            </div>
            <div class="vip-box">
                <div class="vip-list">
                    <div class="vip-list-box">
                        <div class="vip-list-contorl">
                            <div :class="['vip-list-item', activeVipIndex === index && 'vip-list-item-active']"
                                v-for="(item, index) in memberProducts" :key="item.id" @click="activeVipIndex = index">
                                <div class="layer_vip_box">
                                    <div :class="['vip-list-item-text', language]">
                                        <div class="vip-list-item-title">{{ language === 'ug' ? item.nameUig : item.name
                                        }}</div>
                                        <div class="vip-list-item-price">¥<span>{{ item.monthlyPrice }}</span><i
                                                :style="{ padding: language == 'ug' ? '0 2px' : 0 }">/</i>{{ $t('月') }}
                                        </div>
                                        <div class="vip-list-item-free"><span>¥{{ isFirst ? (item.firtstPrice || item.currentPrice) : item.currentPrice
                                        }}</span><span class="vip-list-item-price-origin">¥{{ item.originalPrice
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="first-renew-desc" v-if="item.firtstPrice">{{ $t('首月') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vip-list-desc">
                    {{ resultDesc() }}
                </div>
                <div class="vip-privilege">
                    <div :class="['vip-privilege-title', language == 'ug' && 'vip-privilege-title-ug ug']">
                        <img src="../../assets/livevip/privilege-right-icon.png" alt="">
                        <span>{{ $t('尊享13项会员权益') }}</span>
                        <img src="../../assets/livevip/privilege-left-icon.png" alt="">
                    </div>
                    <div class="vip-privilege-list">
                        <div class="vip-privilege-item" v-for="(item, index) in privilegeList" :key="index">
                            <img class="vip-privilege-item-icon" :src="item.icon" alt="">
                            <div class="vip-privilege-item-text">
                                <span :class="['vip-privilege-item-text-title', language]">{{ $t(item.title) }}</span>
                                <span class="vip-privilege-item-text-desc">{{ $t(item.desc) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="vip-buy">
            <div :class="['vip-buy-btn', language]" @click="handelBuy"> <van-loading v-if="payLoading" size="16"
                    type="spinner" color="#FFFFFF" /> <span class="btn-text">{{ $t('立即开通') }}</span></div>
            <div class="vip-buy-agreement">
                <img @click="isAgreement = !isAgreement"
                    :src="require(`../../assets/livevip/vip-agreement-${isAgreement ? 'select' : 'none'}.png`)" alt="">
                <p>{{ $t("请阅读并同意") }} <span
                        @click="toWebView('https://source.cdtongxiaoyun.com/web/mungdax-Live-service.html', '《mungdax会员服务协议》')">{{
                            $t('《mungdax会员服务协议》') }}</span>、<span
                        @click="toWebView('https://source.cdtongxiaoyun.com/web/mungdax-Live-Membership.html', '《mungdax自动订阅服务协议》')">{{
                            $t('《mungdax自动订阅服务协议》') }}</span></p>
            </div>
        </div>
        <van-dialog v-model="show" :showConfirmButton="false">
            <div class="puy-pay">
                <p :class="['pay-option', language]">{{ $t('选择支付方式') }}</p>
                <div :class="['wxPay', activePay === 'wx' && 'activePay']" @click="handleNoAutoRenewal('wx')">
                    <van-loading v-if="unAutoRenewPayLoading && activePay === 'wx'" size="16" type="spinner"
                        color="#955EFF" />
                    <img src="@/assets/livevip/wx_pay_icon.png" alt="">
                    <span>{{ $t('微信支付') }}</span>
                </div>
                <div :class="['aliPay', activePay === 'ali' && 'activePay']" @click="handleNoAutoRenewal('ali')">
                    <van-loading v-if="unAutoRenewPayLoading && activePay === 'ali'" size="16" type="spinner"
                        color="#955EFF" />
                    <img src="@/assets/livevip/ali_pay_icon.png" alt="">
                    <span>{{ $t('支付宝支付') }}</span>
                </div>
                <div class="close-pay" @click="!unAutoRenewPayLoading && (show = false)">{{ $t('关闭') }}</div>
            </div>
        </van-dialog>
        <!-- 支付表单 -->
        <div class="aliform" v-html="aliform"></div>
    </div>
</template>
<script>
import Navbar from '@/components/Navbar.vue';
import pay from './mixin/pay'
import config from './mixin/config'
import moment from 'moment';

export default {
    components: {
        Navbar
    },
    mixins: [pay, config],
    data() {
        return {
            show: false,
            payLoading: false,
            activePay: '',
            languag: 'ug',
            statusHeight: 0,
            activeVipIndex: 0,
            isAgreement: false,
            privilegeList: [
                { title: '头像框', desc: '等级专属头像框', icon: require('../../assets/livevip/privilege-icon01.png'), },
                { title: '进场特效', desc: '璀璨降临震撼全场', icon: require('../../assets/livevip/privilege-icon02.png'), },
                { title: '在房防踢', desc: '尊享在房不被踢出', icon: require('../../assets/livevip/privilege-icon03.png'), },
                { title: '昵称变色', desc: '专属颜色彰显尊贵', icon: require('../../assets/livevip/privilege-icon04.png'), },
                { title: '订制礼物', desc: '订制礼物排面十足', icon: require('../../assets/livevip/privilege-icon05.png'), },
                { title: '皮肤卡', desc: '至尊身份以卡识人', icon: require('../../assets/livevip/privilege-icon06.png'), },
                { title: '会员标识', desc: '会员勋章专属标识', icon: require('../../assets/livevip/privilege-icon07.png'), },
                { title: '更换房间背景', desc: '专属功能独一无二', icon: require('../../assets/livevip/privilege-icon08.png'), },
                // { title: '游戏皮肤', desc: '赠送美式8球皮肤7天', icon: require('../../assets/livevip/privilege-icon09.png'), },
                // { title: '游戏皮肤', desc: '赠送对战消消乐皮肤7天', icon: require('../../assets/livevip/privilege-icon10.png'), },
                { title: '修改头像昵称', desc: '多次修改头像昵称', icon: require('../../assets/livevip/privilege-icon11.webp'), },
                { title: '麦位专属表情', desc: '专属表情彰显身份', icon: require('../../assets/livevip/privilege-icon12.webp'), },
                { title: '房间专属装饰', desc: '直播列表展示专属装饰', icon: require('../../assets/livevip/privilege-icon13.webp'), },
                { title: '查看访客', desc: '查看所有看过我的人', icon: require('../../assets/livevip/privilege-icon14.webp'), },
                { title: '生日礼包', desc: '生日当天获得专属礼包', icon: require('../../assets/livevip/privilege-icon15.webp'), },
                // { title: '加速升级', desc: '贵族等级1.5倍加速', icon: require('../../assets/livevip/privilege-icon16.webp'), },
            ],
            userInfo: {},
            memberProducts: [],
            aliform: '',
            isUserHaveVip: false,
        }
    },
    methods: {
        resultDate(time) {
            return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : ''
        }
    },
    async created() {
        this.setLanguage();
        this.statusHeight = +this.$route.query.statusBarHeight;
        await this.getToken()
        this.getConfigList()
        this.payStatus()
    },
}
</script>

<style lang="scss" scoped>
.nav-title {
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    white-space: nowrap;
}

.live-vip {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    background-color: #110C24;

    .container {
        flex: 1;
        overflow-y: scroll;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        // transform: translateY(1px);

        .user-box {
            padding: 16px 14px 0 14px;
            position: relative;

            .vip-box-model {
                position: absolute;
                bottom: -1px;
                left: 0;
                width: 100%;
                height: 38px;
                background: url('../../assets/images/service-bg.png') no-repeat;
                background-size: cover;
            }


            .user-card {
                height: 133px;
                background: url('../../assets//livevip/uservip-bg.png') no-repeat;
                background-size: contain;
                padding: 22px 12px;
                box-sizing: border-box;
                position: relative;

                &::after {
                    position: absolute;
                    top: 0;
                    left: 0;
                    content: attr(data-text);
                    width: 54px;
                    height: 18px;
                    line-height: 19px;
                    text-align: center;
                    background: #FA5051;
                    color: #FFFFFF;
                    font-size: 10px;
                    border-radius: 12px 0px 12px 0px;
                }

                .user-info {
                    display: flex;
                    align-items: center;

                    img {
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        margin-right: 4px;
                    }

                    p {
                        width: 200px;
                        font-weight: 500;
                        font-size: 18px;
                        color: #754E51;
                    }
                }

                .vip-desc {
                    width: 223px;
                    font-size: 12px;
                    color: #754E51;
                    padding-top: 8px;
                }

                .active-desc {
                    font-weight: 500;
                    font-size: 12px;
                    color: #FA5051;
                }
            }
        }

        .vip-box {
            flex: 1;
            display: flex;
            overflow: hidden;
            flex-direction: column;
            background-color: #fff;

            .vip-list {
                .vip-list-box {
                    width: 100%;
                    height: 100%;
                    overflow-x: scroll;
                    padding: 2px 0 12px 0;
                    overflow-y: hidden;

                    &::-webkit-scrollbar {
                        display: none;
                    }
                }


                .vip-list-contorl {
                    width: fit-content;
                    display: flex;
                    flex-wrap: nowrap;
                    padding: 0 13px;
                    padding-top: 7px;

                    .vip-list-item {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 110px;
                        height: 121px;
                        border-radius: 12px;
                        box-sizing: border-box;
                        margin-right: 8px;
                        background-color: #EBE3FF;
                        position: relative;

                        .layer_vip_box {
                            width: 106px;
                            height: 115px;
                            padding: 17px 0;
                            border-radius: 10.5px;
                            box-sizing: border-box;
                            background: #FFFFFF;
                        }

                        .first-renew-desc {
                            position: absolute;
                            top: -7px;
                            left: 0;
                            padding: 0 10px;
                            height: 18px;
                            line-height: 18px;
                            background: linear-gradient(90deg, #F64003 0%, #FD8B10 100%);
                            border-radius: 7px 3px 7px 0px;
                            font-size: 10px;
                            color: #FFFFFF;
                            text-align: center;
                        }

                        &:last-child {
                            margin-right: 0;
                        }

                        .vip-list-item-text {
                            height: 100%;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            font-weight: 500;
                            padding: 0 10px;

                            .vip-list-item-title {
                                width: 100%;
                                font-size: 14px;
                                color: #181818;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                text-align: center;
                                padding-bottom: 2px;
                            }

                            .vip-list-item-price {
                                font-size: 12px;
                                padding-top: 20px;
                                color: #333333;

                                span {
                                    font-weight: bold;
                                    font-size: 20px;
                                }
                            }

                            .vip-list-item-free {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                width: 72px;
                                height: 23px;
                                background: #EBE3FF;
                                border-radius: 12px;
                                font-size: 12px;
                                color: #999999;
                                padding: 0 5px;
                                font-weight: 400;
                                box-sizing: border-box;
                                transform: translateY(35px);

                                .vip-list-item-price-origin {
                                    text-decoration: line-through;
                                    font-size: 10px;
                                    padding-left: 6px;
                                }
                            }
                        }
                    }

                    .vip-list-item-active {
                        background: url('../../assets/livevip/vip-bg.png') no-repeat;
                        background-size: cover;
                        position: relative;

                        .layer_vip_box {
                            background-color: transparent;
                            border: none;
                        }

                        .vip-list-item-price {
                            color: #C498FE !important;
                        }

                        .vip-list-item-free {
                            color: #FFFFFF !important;
                            background: #C498FE !important;
                        }
                    }
                }
            }

            .vip-list-desc {
                font-size: 12px;
                color: #999999;
                padding: 0 13px;
                padding-top: 14px;
                line-height: 18px;
            }

            .vip-privilege {
                flex: 1;
                display: flex;
                flex-direction: column;
                padding: 17px 13px 0 13px;
                overflow-y: scroll;

                &::-webkit-scrollbar {
                    display: none;
                }

                .vip-privilege-title {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 500;
                    font-size: 16px;
                    color: #1E2225;
                    padding-bottom: 25px;
                    text-align: center;

                    span {
                        padding: 0 8px;
                    }

                    img {
                        width: 66px;
                        height: 3px;
                    }
                }

                .vip-privilege-title-ug {
                    font-size: 12px;
                    justify-content: space-between;
                }

                .vip-privilege-list {
                    flex: 1;
                    overflow-y: scroll;

                    .vip-privilege-item {
                        display: flex;
                        padding-bottom: 16px;

                        .vip-privilege-item-icon {
                            width: 44px;
                            height: 44px;
                        }

                        .vip-privilege-item-text {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            padding-left: 8px;

                            .vip-privilege-item-text-title {
                                font-weight: 500;
                                font-size: 16px;
                                color: #333333;
                                padding-bottom: 8px;
                            }

                            .vip-privilege-item-text-desc {
                                font-size: 12px;
                                color: #999999;
                            }
                        }
                    }
                }
            }
        }
    }

    .vip-buy {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 17px 20px 10px 20px;
        background-color: #fff;
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.4);

        .vip-buy-btn {
            display: flex;
            justify-content: center;
            width: 100%;
            height: 48px;
            line-height: 48px;
            background: linear-gradient(90deg, #F3A5FF 0%, #C498FE 100%);
            border-radius: 12px;
            font-weight: 500;
            font-size: 18px;
            text-align: center;
            color: #FFFFFF;

            .btn-text {
                padding-left: 10px;
            }
        }

        .vip-buy-agreement {
            display: flex;
            align-items: center;
            padding-top: 10px;
            width: 236px;

            img {
                width: 20px;
                height: 20px;
            }

            .vip-buy-agreement-text {
                flex: 1;
                padding-left: 8px;
                font-size: 12px;
                line-height: 16px;
                color: #1E2225;
                text-align: center;

                span {
                    color: #C498FE;
                }
            }
        }
    }

    .puy-pay {
        display: flex;
        flex-direction: column;
        align-items: center;

        .pay-option {
            font-weight: 500;
            font-size: 18px;
            color: #333333;
            text-align: center;
            padding: 20px 0;
        }

        .wxPay,
        .aliPay {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 265px;
            height: 48px;
            background: #FFFFFF;
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #E8E8E8;
            margin-bottom: 16px;
            transition: all .3s;

            img {
                width: 20px;
                height: 20px;
                margin-right: 8px;
                margin-left: 10px;
            }
        }

        .activePay {
            background: rgba(167, 43, 255, 0.1);
            border: 1px solid #C498FE;
            position: relative;

            &::after {
                content: '';
                width: 17px;
                height: 16px;
                background: url('../../assets/livevip/select-pay-icon.png') no-repeat;
                background-size: cover;
                position: absolute;
                right: 0;
                bottom: 0;
            }
        }

        .close-pay {
            width: 265px;
            text-align: center;
            padding: 6px 0 20px 0;
            font-size: 14px;
            color: #777777;
        }
    }

}

.loading {
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba($color: #000000, $alpha: .3);
    z-index: 99999999;
}
</style>